import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import * as React from 'react'
import Sheet from 'components/utils/Sheet'
import BodyText from 'LuxKit/Typography/BodyText'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import styled from 'styled-components'
import { rem } from 'polished'
import TripLandingAnimatedBackground from 'tripPlanner/Tripkit/TripLandingAnimatedBackground'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { FormattedMessage } from 'react-intl'

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(32)};
  
  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`
const StyledSheet = styled(Sheet)`
  display: grid;
  grid-template: "content" 1fr / 1fr;
  position: relative;
`

const StyledTripLandingAnimatedBackground = styled(TripLandingAnimatedBackground)`
  grid-area: content;
  position: absolute;
  top: ${rem(-48)};
  inset-inline: 0;
  bottom: ${rem(-48)};
  z-index: 0;
`

const ContentContainer = styled.div`
  grid-area: content;
  position: relative;
  z-index: 1;
`
const StyledSheetTransparent = styled(Sheet)`
  background: rgba(255,255,255, 0.16);
`

function TripLandingPageHowItWorks() {
  return (
    <StyledSheet paletteType="inverse" padding="48 0" background="normal-background">
      <StyledTripLandingAnimatedBackground />
      <ContentContainer>
        <LayoutContainer>
          <Group direction="vertical" verticalAlign="center" horizontalAlign="center" gap={32}>
            <HeadingTextBlock variant="heading2">
              <FormattedMessage
                id="DdUCTnwUXDg6DLshisxE"
                defaultMessage="How it <i>works</i>"
                description="Heading for how it works section in the trip planner feature"
                values={{
                  i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
                }}
              />
            </HeadingTextBlock>
            <GridContainer>
              <StyledSheetTransparent
                paletteType="inverse"
                padding="24 20"
                borderRadius="L"
              >
                <Group direction="vertical" horizontalAlign="center" gap={12}>
                  <ResponsiveImage id="wu92zsltjcbuyq7qoo4a" width={80} height={80} />
                  <VerticalSpacer gap={4}>
                    <Group direction="vertical" horizontalAlign="center" gap={4}>
                      <Heading variant="heading5" align="center">
                        <FormattedMessage
                          id="DjyGFsRZzDquTgNYOpxz"
                          defaultMessage="Tell us about your trip"
                          description="Heading for tell us about your trip section in the trip planner"
                        />
                      </Heading>
                      <BodyText variant="large" align="center">
                        <FormattedMessage
                          id="LI-cDTi1Ac236FqLCI4M"
                          defaultMessage="Choose your destination, travel dates, and what kind of experience you’re after."
                          description="Description for tell us about your trip section in the trip planner"
                        />
                      </BodyText>
                    </Group>
                  </VerticalSpacer>
                </Group>

              </StyledSheetTransparent>
              <StyledSheetTransparent
                paletteType="inverse"
                padding="24 20"
                borderRadius="L"
              >
                <Group direction="vertical" horizontalAlign="center" gap={12}>
                  <ResponsiveImage id="msgvpmjw9gcv9i48elto" width={80} height={80} />
                  <VerticalSpacer gap={4}>
                    <Group direction="vertical" horizontalAlign="center" gap={4}>
                      <Heading variant="heading5" align="center">
                        <FormattedMessage
                          id="5-XDdb3rMkH2JMNqmbAm"
                          defaultMessage="We build your itinerary instantly"
                          description="Heading for we build your itinerary instantly section"
                        />
                      </Heading>
                      <BodyText variant="large" align="center">
                        <FormattedMessage
                          id="506y29QBZVeUYq9Sseb-"
                          defaultMessage="Our smart AI, guided by travel experts builds a personalised, bookable trip just for you."
                          description="Description for our smart AI, guided by travel experts builds a personalised, bookable trip just for you section"
                        />
                      </BodyText>
                    </Group>
                  </VerticalSpacer>
                </Group>
              </StyledSheetTransparent>
              <StyledSheetTransparent
                paletteType="inverse"
                padding="24 20"
                borderRadius="L"
              >
                <Group direction="vertical" horizontalAlign="center" gap={12}>
                  <ResponsiveImage id="2qma9scdehdx12s2dd9m" width={80} height={80} />
                  <VerticalSpacer gap={4}>
                    <Group direction="vertical" horizontalAlign="center" gap={4}>
                      <Heading variant="heading5" align="center">
                        <FormattedMessage
                          id="OFXWLic0SyuEpGeKAIF4"
                          defaultMessage="Tweak, share and book"
                          description="Heading for tweak, share and book section for sharing content"
                        />
                      </Heading>
                      <BodyText variant="large" align="center">
                        <FormattedMessage
                          id="wGTVTMnqmu-FBES7F7OS"
                          defaultMessage="Change anything you like, share with others, and travel stress-free with every detail in one place."
                          description="Description for tweak, share and book section in the trip planner"
                        />
                      </BodyText>
                    </Group>
                  </VerticalSpacer>
                </Group>
              </StyledSheetTransparent>
            </GridContainer>
          </Group>
        </LayoutContainer>
      </ContentContainer>
    </StyledSheet>
  )
}

export default TripLandingPageHowItWorks
